import axios from "axios";
import { redirectUrl } from "config";
import { baseUrl } from "config";
import { useSnackBar } from "context/snackbarContext";
import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";

function Print() {
  const location = useLocation();
  const hasPrinted = useRef(false);
  const {
    data,
    tableData,
    qrData,
    printType,
    typ,
    isInvoiceData,
    invoiceOnly,
    kotTableData,
    kotNo,
    navigateBackThermalDirect = -1,
    navigateBack = -2,
  } = location.state || {};

  const user = useSelector((state) => state?.common?.userDetail?.user);
  const { companyInfo } = useSelector((state) => state?.common);

  const navigate = useNavigate();
  const { showSnackbar } = useSnackBar();

  useEffect(() => {
    if (!location.state || hasPrinted.current) return;
    hasPrinted.current = true;

    const renderComponent = () => {
      switch (printType) {
        case "LazerA4PrintB2b_TAXGST":
          if (typ === "DN") {
            return navigate("/printer/deliveryNote", {
              state: {
                data: data,
                tableData: tableData,
                qrData: qrData,
                typ: typ,
                navigateBack: navigateBack === -2 ? -1 : navigateBack,
              },
              replace: true,
            });
          }
          if (
            typ === "SB" ||
            typ === "SR" ||
            typ === "SRB2C" ||
            typ === "OF" ||
            typ === "B2C"
          ) {
            return navigate("/printer/a4", {
              state: {
                data: data,
                tableData: tableData,
                qrData: qrData,
                typ: typ,
                navigateBack: navigateBack === -2 ? -1 : navigateBack,
              },
              replace: true,
            });
          } else {
            return navigate("/printer/purchaseA4", {
              state: {
                data: data,
                tableData: tableData,
                qrData: qrData,
                typ: typ,
                navigateBack: navigateBack === -2 ? -1 : navigateBack,
              },
              replace: true,
            });
          }
        case "LazerA4PrintB2b_TAXGST_two":
          if (typ === "DN") {
            return navigate("/printer/deliveryNote", {
              state: {
                data: data,
                tableData: tableData,
                qrData: qrData,
                typ: typ,
                navigateBack: navigateBack === -2 ? -1 : navigateBack,
              },
              replace: true,
            });
          }
          if (
            typ === "SB" ||
            typ === "SR" ||
            typ === "SRB2C" ||
            typ === "OF" ||
            typ === "B2C"
          ) {
            return navigate("/printer/a4Two", {
              state: {
                data: data,
                tableData: tableData,
                qrData: qrData,
                typ: typ,
                navigateBack: navigateBack === -2 ? -1 : navigateBack,
              },
              replace: true,
            });
          } else {
            return navigate("/printer/purchaseA4", {
              state: {
                data: data,
                tableData: tableData,
                qrData: qrData,
                typ: typ,
                navigateBack: navigateBack === -2 ? -1 : navigateBack,
              },
              replace: true,
            });
          }

        case "ThermalPrintB2b_TAXGST":
          if (
            typ === "SB" ||
            typ === "SR" ||
            typ === "SRB2C" ||
            typ === "B2C" ||
            typ === "DN"
          ) {
            return navigate("/printer/thermalPrint", {
              state: {
                data: data,
                tableData: tableData,
                qrData: qrData,
                typ: typ,
                navigateBack: navigateBack === -2 ? -1 : navigateBack,
              },
              replace: true,
            });
          } else {
            return navigate("/printer/purchaseThermal", {
              state: {
                data: data,
                tableData: tableData,
                qrData: qrData,
                typ: typ,
                navigateBack: navigateBack === -2 ? -1 : navigateBack,
              },
              replace: true,
            });
          }
        case "LazerA4PrintB2b_TAXVAT":
          if (typ === "DN") {
            return navigate("/printer/deliveryNote", {
              state: {
                data: data,
                tableData: tableData,
                qrData: qrData,
                typ: typ,
                navigateBack: navigateBack === -2 ? -1 : navigateBack,
              },
              replace: true,
            });
          }
          return navigate("/printer/lazerA4PrintTaxVat", {
            state: {
              data: data,
              tableData: tableData,
              qrData: qrData,
              typ: typ,
              navigateBack: navigateBack === -2 ? -1 : navigateBack,
            },
            replace: true,
          });
        case "ThermalPrintB2b_TAXVAT":
          return navigate("/printer/ThermalPrintTaxVat", {
            state: {
              data: data,
              tableData: tableData,
              qrData: qrData,
              typ: typ,
              navigateBack: navigateBack === -2 ? -1 : navigateBack,
            },
            replace: true,
          });
        case "THERMAL_3INCH_DIRECT_VAT_2":
          return navigate("/printer/ThermalPrintTaxVat2", {
            state: {
              data: data,
              tableData: tableData,
              qrData: qrData,
              typ: typ,
              navigateBack: navigateBack === -2 ? -1 : navigateBack,
            },
            replace: true,
          });
        case "ThermalPrint4Inch_TAXVAT":
          return navigate("/printer/thermalPrint4Inch", {
            state: {
              data: data,
              tableData: tableData,
              qrData: qrData,
              typ: typ,
              navigateBack: navigateBack === -2 ? -1 : navigateBack,
            },
            replace: true,
          });
        case "THERMAL_3INCH_DIRECT":
          // navigate(-1);
          navigate(navigateBackThermalDirect);
          return axios({
            method: "post",
            url: baseUrl + "/print",
            data: {
              master: data,
              table: tableData,
              typ: "THERMAL_3INCH_DIRECT",
              isInvoiceData,
              invoiceOnly,
              qrData: qrData,
              kotTableData,
              kotNo,
            },
            withCredentials: true,
          })
            .then((res) => {})
            .catch((err) => {
              showSnackbar("error", err?.response?.data?.message);

              if (err.response.status === 403 || err.response.status === 401) {
                redirectUrl();
              }
            });
        case "THERMAL_3INCH_DIRECT_VAT":
          navigate(navigateBackThermalDirect);
          return axios({
            method: "post",
            url: baseUrl + "/print",
            data: {
              master: data,
              table: tableData,
              typ: "THERMAL_3INCH_DIRECT_VAT",
              isInvoiceData,
              invoiceOnly,
              qrData: qrData,
              kotTableData,
              kotNo,
            },
            withCredentials: true,
          })
            .then((res) => {})
            .catch((err) => {
              showSnackbar("error", err?.response?.data?.message);

              if (err.response.status === 403 || err.response.status === 401) {
                redirectUrl();
              }
            });
        case "ELECTRON_LOCAL_JSON_PRINT":
          navigate(navigateBackThermalDirect, { replace: true });
          return axios({
            method: "post",
            url: baseUrl + "/electron-print",
            data: {
              username: user,
              master: data,
              table: tableData,
              qrData,
              typ,
              isInvoiceData: {
                ...(typ === "SR"
                  ? {
                      isSalesReturn: true,
                      isSalesReturnB2B: true,
                      isSalesReturnB2C: false,
                      isInvoice: false,
                      isKot: false,
                      isALLKot: false,
                    }
                  : typ === "SRB2C"
                  ? {
                      isSalesReturn: true,
                      isSalesReturnB2B: false,
                      isSalesReturnB2C: true,
                      isInvoice: false,
                      isKot: false,
                      isALLKot: false,
                    }
                  : {}),
                ...(isInvoiceData || {}),
              },
              invoiceOnly,
              kotTableData,
              kotNo,
              companyInfo,
              serverId: localStorage.getItem("serverId"),
            },
            withCredentials: true,
          })
            .then((res) => {})
            .catch((err) => {
              showSnackbar("error", err?.response?.data?.message);

              if (err.response?.status === 403 || err.response?.status === 401) {
                redirectUrl();
              }
            });
        case "APP_PRINT":
          return axios({
            method: "post",
            url: baseUrl + "/app-print",
            data: {
              username: user,
              master: data,
              table: tableData,
              qrData,
              typ,
              isInvoiceData,
              invoiceOnly,
              kotTableData,
              kotNo,
              companyInfo,
              serverId: localStorage.getItem("serverId"),
            },
            withCredentials: true,
          })
            .then((res) => {
              showSnackbar("success", res?.data?.message || "App print request sent successfully");
              navigate(navigateBackThermalDirect, { replace: true });
            })
            .catch((err) => {
              if (err.response?.status === 403 || err.response?.status === 401) {
                redirectUrl();
                return;
              }

              showSnackbar(
                "warning",
                (err?.response?.data?.message ? err?.response?.data?.message + " - " : "") +
                  "Mobile printer offline. Falling back to Thermal 3-Inch Direct Arabic..."
              );

              // Fallback to THERMAL 3 INCH DIRECT ARABIC-2 (/printer/ThermalPrintTaxVat2)
              return navigate("/printer/ThermalPrintTaxVat2", {
                state: {
                  data: data,
                  tableData: tableData,
                  qrData: qrData,
                  typ: typ,
                  navigateBack: navigateBack === -2 ? -1 : navigateBack,
                  navigateBackThermalDirect: navigateBackThermalDirect,
                },
                replace: true,
              });
            });
        case "QUOTATION_PRINT":
          return navigate("/printer/quotationPrint", {
            state: {
              data: data,
              tableData: tableData,
              qrData: qrData,
              typ: typ,
              navigateBack: navigateBack === -2 ? -1 : navigateBack,
            },
            replace: true,
          });
        case "ESTIMATE":
          return navigate("/printer/newInvoicePrint", {
            state: {
              data: data,
              tableData: tableData,
              qrData: qrData,
              typ: typ,
              navigateBack: navigateBack === -2 ? -1 : navigateBack,
            },
            replace: true,
          });
        default: {
          // navigate(-1);
          navigate(navigateBackThermalDirect);
          return showSnackbar("error", `Please select printer`);
        }
      }
    };
    renderComponent();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, navigate, printType, qrData, tableData, typ]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        gap: "16px",
        backgroundColor: "#f8fafc",
      }}
    >
      <div
        style={{
          border: "4px solid #f3f3f3",
          borderTop: "4px solid #3498db",
          borderRadius: "50%",
          width: "36px",
          height: "36px",
          animation: "spin 1s linear infinite",
        }}
      />
      <span style={{ fontSize: "14px", color: "#64748b", fontFamily: "sans-serif" }}>
        Processing Print Request...
      </span>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default Print;
